import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/feed/page.tsx");
